import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const GpfFinalPrint = () => {
  const navigate = useNavigate();
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);

        setPensionProposalData(singleData);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId]);
  const [formData, setFormData] = useState([]);
  const [familyMember, setfamilyMember] = useState([]);
  useEffect(() => {
    try {
      if (PensionProposalData?.formData) {
        setFormData(JSON.parse(PensionProposalData.formData));
      }
      if (PensionProposalData?.familyMember) {
        setfamilyMember(JSON.parse(PensionProposalData.familyMember));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [PensionProposalData]);

  const [serviceDurationYears, ServiceDurationYears] = useState(0);
  const [serviceDurationMonth, setServiceDurationMonth] = useState(0);
  // Update the home rent whenever formData changes
  useEffect(() => {
    // Function to extract years (वर्ष) as a string
    const getYears = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

        if (yearsPart) {
          // Extract the number before "वर्ष" using regex
          const match = yearsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }
      }

      return null; // Return null if "वर्ष" is not found
    };
    const getMonths = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const monthsPart = parts.find((part) => part.includes("महिने")); // Find the part with "महिने"

        if (monthsPart) {
          // Extract the number before "महिने" using regex
          const match = monthsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }

        return null; // Return null if "महिने" is not found
      }
    };

    // Example usage:
    const months = getMonths(formData && formData.serviceDuration);

    const years = getYears(formData && formData.serviceDuration);
    setServiceDurationMonth(
      months >= 3 && months < 9 ? 1 : months >= 9 && months < 12 ? 2 : 0
    );

    const result = getYears(formData.serviceDuration);
    ServiceDurationYears(result); // Output: "4 वर्ष"
  }, [formData.serviceDuration]);

  const [serviceDurationMonth1, setServiceDurationMonth1] = useState(0);

  useEffect(() => {
    setServiceDurationMonth1(
      serviceDurationYears > 33
        ? Math.round(33 * 2)
        : Math.round(serviceDurationYears * 2 + serviceDurationMonth)
    );
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
    serviceDurationYears,
    serviceDurationMonth,
  ]);

  const generatePrintablePage = async () => {
    // Add dynamic CSS for proper page breaks and consistent layout
    const style = document.createElement("style");
    style.innerHTML = `
        /* General styling */
        * {
          padding: 0px !important;
          margin: 0px !important;
          font-size: 14px !important;
          color: #000 !important;
          box-sizing: border-box; /* Maintain consistent sizing */
        }
          .commonClassTable{
          margin: 0px 0 !important;
          width:100% !important;
        }
        #gpf-final-print {
          width: 100%;
        }
        table th,table td{
          padding: 2px 5px !important;
          
        }
          .tableHeading,tableHeading1{
          font-size:12px !important;}
          
        /* Ensure each section prints on its own page */
        #gpf-final-print > div {
          page-break-after: always; /* Force each child div to print on a new page */
          page-break-inside: avoid; /* Avoid breaking inside sections */
        }
        
  
        /* Page setup */
        @page {
          size: A4; /* Set the page size to A4 */
          margin: 10mm 10mm 10mm 10mm !important; /* Set page margin */
        }
    
        @media print {
          body {
            margin: 0;
            padding: 0;
          }
    
          /* Hide unnecessary sections like buttons */
          #button-section {
            display: none;
          }
        }
      `;
    document.head.appendChild(style);

    // Get the #inter-district-transfer-print element
    const printContent = document.getElementById("gpf-final-print");

    if (printContent) {
      // Clone the content for printing
      const printWrapper = document.createElement("div");
      printWrapper.id = "print-wrapper";

      // Clone each child element of #inter-district-transfer-print
      Array.from(printContent.children).forEach((child) => {
        const clone = child.cloneNode(true);
        printWrapper.appendChild(clone);
      });

      // Append the cloned content to the body
      document.body.appendChild(printWrapper);

      // Trigger the print dialog
      window.print();

      // Clean up after printing
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };

  return (
    <div className="container-xl py-3">
      <div className="row my-4" id="button-section">
        <div className="col-lg-4">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/dashboard/pension_proposal")}
          >
            Back
          </button>
        </div>
      </div>
      <div id="gpf-final-print" className="gpf-final-print mt-3">
        <div id="section1" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7"></div>
            <div className="col-lg-5 col-md-5 ms-auto">
              <p className="fw-bold text-danger">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold text-danger">
                {formData && formData.officeName}
              </p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1"> मुख्य लेखा व वित्त अधिकारी</p>
          <p className="fw-bold text-danger mt-1">
            {formData && formData.currentDistrict}
          </p>

          <p className="fw-bold text-left mt-3">
            प्रकरण :- भविष्य निर्वाह निधी अंतिम प्रदान रक्कम मिळणे बाबतचा
            प्रस्ताव सादर करणेबाबत
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="fw-bold text-left mt-2">
            {" "}
            भविष्य निर्वाह निधी खाते क्रमांक : {formData && formData.gpfNumber}
          </p>
          <p className=" text-left mt-2">
            संदर्भ : संबंधिताचा अंतिम प्रदान प्रस्ताव दिनांक
          </p>
          <p className="mt-3">महोदय,</p>

          <p className="mt-1 mb-3 textIndent">
            वरिल संदर्भिय विषयाच्या अनुषंगाने सविनय सादर करण्यात येते की,{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            <b>{formData && formData.retirementDate}</b> रोजी{" "}
            {formData && formData.retirementType} नुसार सेवानिवृत्त झाले आहे.
            त्यांचे भविष्य निर्वाह निधी अंतिम रक्कम मिळणेबाबत विहीत नमुण्यातील
            प्रस्ताव पुढील कार्यवाहीस्तव सादर करण्यात येत आहे कृपया स्विकार
            व्हावा ही विनंती.
          </p>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>

          <div className="pt-4">
            <p>सोबत - </p>
            <p>
              1. {formData && formData.fullName},
              {formData && formData.designation}
            </p>
            <p>2. भविष्य निर्वाह निधी खाते पुस्तिका स्लिप</p>
            <p>3. नादेय / ना खाते चौकशी प्रमाणपत्र.</p>
          </div>
        </div>

        <div id="section2" className="commonClassTable border px-5 py-5">
          <div className="text-center mb-4">
            <h3 className="fw-bold text-2xl">FORM B</h3>
            <p className="fw-bold text-xl">जी पी एफ - संपूर्ण</p>
            <p className="text-base">
              Vide Govt. Resolution G.A.D. Gen 295 E No. PFR
              1061-23963-5414,dated 4 -10 -61
            </p>
            <p className="text-base">(For Non - Gazettes Officers)</p>
            <p className="text-base">
              Form of Application for Final Payment / Transfer to Corporate
              Bodies/ Other Government of
            </p>
            <p className="text-center text-base">
              Balances in the : {formData && formData.gpfNumber}
            </p>
          </div>
          <div>
            <div className="mb-3">
              <p>To,</p>
              <p className="fw-bold mt-1">
                {formData && formData.currentDistrict}
              </p>
              <p className="fw-bold mt-1">(through the Head of Office)</p>
            </div>

            <p className="textIndent mt-1">
              1) I am due to retire / have retired and have proceeded on leave
              preparatory to Retirement for months{" "}
              <b>{formData && formData.gpfNumber}</b> have been discharged /
              dismissed / have been permanently transferred to NIL have resigned
              finally from Government Service / have resigned services under NIL
              Government to take up appointment with NIL and my resignation has
              been accepted with effect from NIL Forenoon / Afternoon .With NIL
              on forenoon / afternoon. I Joined service
            </p>
            <p className="textIndent mt-1">
              2) I request that entire amount at my creait with interest aue
              under the rules iviay De paid to me transferred to NIL
            </p>

            <p className="textIndent mt-1">
              3) My Provident fund Account No is
              <b className="text-danger">{formData && formData.gpfNumber}</b>
            </p>
            <p className="textIndent mt-1">
              4) I desire to receive payment through my office through the{" "}
              {formData && formData.currentDistrict}
            </p>
            <p className="textIndent mt-1">
              Sub:- Treasury. Particulars of my personal marks of identification
              (left hand thumb and finger) impressions (in the case of
              illiterate subscribers and Specimen signature in the case of
              literate subscribers in duplicate duly attested by a gazette
              officer of the Government are enclosed.
            </p>
            <p className="textIndent mt-1">
              5) The under mentioned life insurance policy by me from my
              provident Fund Account may kindly be released.
            </p>

            <div className="mt-3">
              <table className="table table-bordered border-black">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Policy No.</th>
                    <th>Name of Co.</th>
                    <th>Sum Assured</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
              <p className="">
                कार्यालयाचे नाव :- {formData && formData.officeName}
              </p>
            </div>

            <div className="row g-2 align-items-center">
              <div className="col-lg-6 col-6 col-md-6 text-center">
                <p className="fw-bold">नाव / पदनाम व संपूर्ण पत्ता</p>
                <p className="fw-bold">
                  {formData && formData.fullName},{" "}
                  {formData && formData.designation}
                </p>
                <p className="fw-bold">{formData && formData.address}</p>
              </div>
              <div className="col-lg-6 col-6 col-md-6 text-center">
                <p className="">आपला विश्वासू</p>
                <p className="text-start py-3 ps-5">स्वाक्षरी :-</p>
                <p className="mb-0 fw-bold">{formData && formData.fullName}</p>
                <p className="mb-0 fw-bold">
                  {formData && formData.designation}
                </p>
                <p className="mb-0 fw-bold">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section3" className="commonClassTable border px-5 py-4">
          <div className="text-center">
            <p className="mb-3">
              This applies only payment is not desired through the Head Office
              Please Score out if not necessary.
            </p>
            <h3 className="fw-bold text-2xl">(For use by Head of Offices)</h3>

            <p>
              Forwarded to the Accountant General{" "}
              {formData && formData.currentDistrict}
            </p>

            <p className="text-danger fw-bold">
              For necessary action : {formData && formData.gpfNumber}
            </p>
          </div>
          <p className="textIndent fw-bold text-danger pt-3">
            2. The Provident Fund Account No. of :
            {formData && formData.fullName}, {formData && formData.designation}
          </p>
          <p className="textIndent mt-2">
            3. He/ She has finally retired / Will retire/ has proceeded on leave
            preparatory on leave preparatory to retirement for months/ has been
            discharged/ dismissed/has been permanently transferred to
            __________________ has resigned finally from Government service/has
            resigned service under Government ot take up appointment with
            _______________________ and his / her resignation Has been accepted
            with effect ________________________ Forenoon / afternoon. He Joined
            service with forenoon afternoon.
          </p>

          <p className="textIndent mt-2">
            4. The last fund deduction was made from his /her pay in this office
            Bill No.
          </p>

          <table className="table table-bordered border-black text-center mt-4">
            <thead>
              <tr>
                <th>Vr No.& Dated</th>
                <th>For Rs</th>
                <th></th>
                <th>Rupees</th>
                <th></th>
                <th> Cash Vouchers</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>No.</td>
                <td>Of</td>
                <td colSpan={4} className="text-left">
                  Treasury the amount of deduction being Rs.
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colSpan={4} className="text-left">
                  And recovery on account of refund advance Rs,
                </td>
              </tr>
            </tbody>
          </table>

          <p className="textIndent mt-2">
            5. Certified that he / she was neither sanctioned any temporary any
            temporary advance nor any final with drawl from his/ her provident
            Fund account during the 12 months immediately preceding the date of
            his /her quitting service under __________________________
            Government proceeding on leave preparatory to retirement or
            thereafter. Certified that the following temporary advances / final
            with drawls were sanctioned to him / her and preceding from his /her
            provident fund Account during the 12 months immediately preceding
            the date of his /her quitting service under Government preparatory
            or leave preparatory to retirement or thereafter.
          </p>
          <p className="textIndent mt-2">
            <b>
              Amount of Advance / with drawl NIL DATE -NIL VOUCHER NO.
              __________________________{" "}
            </b>
          </p>

          <p className="textIndent mt-2">
            6. Certified that no Amount was withdrawn / the following Amount was
            withdrawn from his / her Provident fund account during the 12 months
            immediately proceeding the date of his/her quitting service under
            NIL Government proceeding to leave preparatory to retirement or
            there after for payment of Insurance premium or for the purchase of
            new policy
          </p>

          <p className="textIndent mt-2">
            <b>
              Amount of Advance / withdrawl NIL DATE - NIL Voucher No. NIL
              __________________________
            </b>
          </p>
          <p className="textIndent mt-2">
            7. It is certified that he / she has no resigned from Government
            Service with proper permission of the State Govt. to take up an
            appointment in another Dept. of the State or another State or
            Central Govt. or under a body corporate owned or controlled by the
            State or Central Government
          </p>

          <p className="text-end pt-5 fw-bold">Signature of Office</p>
          <p className="pt-3">
            Certificate No. 7 to be furnished in the case of contributory
            Provident Funds only please score out if not necessary
          </p>
        </div>

        <div id="section4" className="commonClassTable border px-5 py-4">
          <div className="certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mb-2">
              • नाचौकशी प्रमाणपत्र •
            </h3>
            <p className="textIndent">
              प्रमाणित करण्यात येते को,{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              यांच्याविरूध्द कोणतीही खाते निहाय चौकशी प्रलंबीत अथवा प्रस्तावित
              नाही. करतांना चौकशी प्रमाणपत्र देण्यात येत आहे
            </p>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6">
                {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
              </div>

              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>

          <div className="certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mt-5 mb-2">
              • प्रमाणपत्र •
            </h3>
            <p className="textIndent">
              प्रमाणित करण्यात येते को,{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              यांच्या कड जिल्हा परिषदचे/ विभागाचे कोणते ही शकीत येणे बाकी नाही.{" "}
              करतांना चौकशी प्रमाणपत्र देण्यात येत आहे
            </p>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6"></div>

              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>

          <div className="certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mt-5 mb-2">
              • वचन पत्र •
            </h3>
            <p className="textIndent">
              मी{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              असे वचनपत्र लिहून देतो की, भविष्य निर्वाह निधी च्या अंतिम प्रदानात
              विरांगती आढळून आल्यामुळे मला अतिप्रदान झाल्याचे निदर्शास आल्यास ते
              भविष्यात मला प्रदान करण्यात येणाऱ्या निवृत्ती वेतन / उपदान /
              अंशराशीकरण रकमेतून समायोजीत करून किंवा इतर प्रकारे मी शासनात परत
              करीन.{" "}
            </p>
            <p className="textIndent">करिता वाचनपत्र लिहून देण्यात येत आहे.</p>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold">
                  {formData && formData.fullName},
                  {formData && formData.designation},
                </p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
          </div>

          <div className="certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mt-5 mb-2">
              • नमुना स्वाक्षरी बाबत प्रमाणपत्र •
            </h3>
            <p className="textIndent">
              प्रमाणित करण्यात येते की,
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},
                {formData && formData.officeName}
              </b>{" "}
              यांनी खालील स्वाक्षरी माझ्या समक्ष केलेल्या आहे
            </p>

            <div className="table-responsive mt-4">
              <table className="table w-75 m-auto text-center table-bordered border-black">
                <thead>
                  <tr>
                    <th> 1.</th>
                    <th> 2.</th>
                    <th> 3.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="py-5"></td>
                    <td className="py-5"></td>
                    <td className="py-5"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="textIndent mt-3">करिता प्रमाणित करण्यात येत आहे.</p>

            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6 text-center"></div>
              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section5" className="commonClassTable border px-5 py-5">
          <div className="certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mt-5 mb-2">
              • ६ वा वेतन आयोग प्रमाणपत्र •
            </h3>
            <p className="textIndent">
              प्रमाणित करण्यात येते की,{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              हे दिनांक <b>{formData && formData.retirementDate}</b> रोजी सेवा
              निवृत्त झालेले आहेत. संबंधितांचे सहाव्या वेतन आयोगाची फरकाची रक्कम
              संबधितांस खालील प्रमाण अदा करण्यात आलेली आहे.
            </p>

            <table className="m-auto table table-bordered border-black mt-3 w-50">
              <tbody>
                <tr>
                  <th>हप्ता क्र</th>
                  <th>रक्कम</th>
                </tr>
                <tr>
                  <td>पहिला हप्ता</td>
                  <td></td>
                </tr>
                <tr>
                  <td>दुसरा हप्ता</td>
                  <td></td>
                </tr>
                <tr>
                  <td>तिसरा हप्ता</td>
                  <td></td>
                </tr>
                <tr>
                  <td>चौथा हप्ता</td>
                  <td></td>
                </tr>
                <tr>
                  <td>पाचवा हप्ता</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <p className="textIndent mt-3">
              सदर हप्त्याची नोंद संबंधिताचे भविष्य निर्वाह निधी खाते
              पुस्तिकेमध्ये घेण्यात आलेली आहे{" "}
            </p>
            <p className="textIndent">कारता प्रमाणित करण्यात येत आहे.</p>

            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6 text-center"></div>
              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
          <div className=" certificate">
            <h3 class="text-center py-3 text-2xl fw-bold mt-5 mb-2">
              • ७ वा वेतन आयोग प्रमाणपत्र •
            </h3>

            <p className="textIndent">
              प्रमाणित करण्यात येते की,{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              हे दिनांक <b>{formData && formData.retirementDate}</b> रोजी सेवा
              निवृत्त झालेले आहेत. संबंधितांचे सातव्या वेतन आयोगाची फरकाची
              पहिल्या हप्त्याची रक्कम रु{" "}
              <input
                type="text"
                readOnly
                className="bg-white border-black border"
              />
            </p>

            <p className="textIndent mt-2">
              संबधितांस माहे ऑगष्ट देय सप्टेंबर २०१९ च्या मासिक वेतनामध्ये कपात
              करून संबधिताचे भविष्य निर्वाह निधी खात्यावर जमा करण्यात आलेली आहे.
            </p>

            <p className="textIndent mt-2">
              <b>
                प्रमाणक क्र :{" "}
                <input
                  type="text"
                  readOnly
                  className="bg-white border-black border"
                />
              </b>
              {"  "}
              <b>
                दिनाक :{" "}
                <input
                  type="text"
                  readOnly
                  className="bg-white border-black border"
                />
              </b>
            </p>
            <p className="textIndent mt-2">कारता प्रमाणित करण्यात येत आहे.</p>

            <div className="row mt-5 align-items-center">
              <div className="col-lg-6 col-6 col-md-6 text-center"></div>
              <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section6" className="commonClassTable border px-5 py-5">
          <h3 class="text-center py-3 text-2xl fw-bold mb-2">
            आगाऊ पावती / Advance <br />
            Receipt
          </h3>

          <p className="text-center pt-5">
            कर्मचाऱ्यांची ठेव संलग्न योजनेचा लाभ मिळण्यासाठी
          </p>

          <p className="textIndent mt-3">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांना नियमाप्रमाणे अनुज्ञेय असलेली रक्कम जमा / शिल्लक असलेल्या
            भविष्य निर्वाह निधीमधून मिळण्याचा हक्क असलेली एकूण रक्कम
            _______________ रुपये मात्र मिळाली आहे
          </p>

          <div className="row align-items-center">
            <div className="col-lg-6 col-6 col-md-6">
              <p className="fw-bold mt-2">दिनांक :-</p>
              <p className="fw-bold mt-3">ठिकाण :-</p>
            </div>

            <div className="col-lg-6 col-6 col-md-6 text-center">
              <textarea
                className="border border-black bg-white"
                rows={6}
                cols={15}
                readOnly
              ></textarea>
              <p className="fw-bold">
                {formData && formData.fullName},{" "}
                {formData && formData.designation}
              </p>
              <p className="fw-bold">{formData && formData.officeName}</p>
            </div>
          </div>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-6 col-6 col-md-6">
              <p>माझा बँकेचा तपशील खालील प्रमाणे आहे </p>

              <p className="fw-bold mt-2 textIndent">
                १. बँकेचे नाव व शाखां :-{" "}
                {formData && formData.bankNameBranchAddress}
              </p>
              <p className="fw-bold mt-2 textIndent">
                २. बँक खाते क्रंमाक : {formData && formData.accountNumber}
              </p>
              <p className="fw-bold mt-2 textIndent">
                ३. IFSC कोड : {formData && formData.ifscCode}
              </p>
              <p className="fw-bold mt-2 textIndent">
                ४. कर्मचाऱ्याचा मोबाईल क्र : {formData && formData.mobile}
              </p>
            </div>
            <div className="col-lg-6 col-6 col-md-6 text-center pt-6">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section7" className="commonClassTable px-3 py-4">
          <h3 class="text-center text-2xl fw-bold mb-1">
            भविष्य निर्वाह निधी परतावा / नापरतवा अंतिम अदायगी प्रस्ताव तपासणी
            सुची{" "}
          </h3>
          <p className="fw-bold text-center">
            कार्यालय प्रमुख व विभाग प्रमुख कायां लयाची तपासणी सुची
          </p>

          <table className="table table-bordered border-black mt-1">
            <tbody>
              <tr>
                <th>१</th>
                <th>कर्मचाऱ्याचे नाव व पदनाम</th>
                <th>
                  {" "}
                  {formData && formData.fullName},
                  {formData && formData.designation},{" "}
                </th>
              </tr>
              <tr>
                <th>२</th>
                <th>कार्यालयाचे नाव</th>
                <th>{formData && formData.officeName}</th>
              </tr>
              <tr>
                <th>३</th>
                <th>विभागाचे नाव </th>
                <th>{formData && formData.currentDistrict}</th>
              </tr>
              <tr>
                <th>४</th>
                <th>भविष्य निर्वाह निधी क्रमांक </th>
                <th>{formData && formData.gpfNumber}</th>
              </tr>
              <tr>
                <th>५</th>
                <th>मयत नियत वयोमान / सेवा निवृत्ती प्रकार</th>
                <th>{formData && formData.retirementType}</th>
              </tr>

              <tr>
                <th>६</th>
                <th>अंतिम वर्गणी कपात रक्कम व प्रमाणंक क्रमांक</th>
                <th></th>
              </tr>
              <tr>
                <th>७</th>
                <th>भविष्य निर्वाह निधी मागणी केलेली रक्कम</th>
                <th></th>
              </tr>
              <tr>
                <th>८</th>
                <th>
                  भविष्य निर्वाह निधी नियम १९९८ चे कोणत्या नियमान्वये प्रस्ताव
                  सादर केला आहे
                </th>
                <th>भनि नि नियम १९९८ चे नियम २७.२८.२९</th>
              </tr>
              <tr>
                <th>९</th>
                <th>अंतिम अदायगी वित्त विभागाची मान्यता दिनांक</th>
                <th></th>
              </tr>
              <tr>
                <th>१०</th>
                <th>धनादेश कोणाच्या नावांने द्यावयाचा आहे.</th>
                <th>{formData && formData.fullName}</th>
              </tr>
              <tr>
                <th>११</th>
                <th>वारसदारा बाबत खात्री केली आहे काय ? वारसदाराचे नांव</th>
                <th>{formData && formData.wifeHusbandName}</th>
              </tr>
              <tr>
                <td>12</td>
                <td> भविष्य निर्वाह निधी मधुन रक्कम काढण्याचे कारण</td>
                <th>{formData && formData.retirementType}</th>
              </tr>
              <tr>
                <th>१३</th>
                <th>भविष्य निर्वाह निधी मधुन पुवी उचल केल्याचे कारण</th>
                <td>निरंक</td>
              </tr>
              <tr>
                <th>१४</th>
                <th>कर्मचाऱ्यांची एकुण सेवा कालावधी</th>
                <th>{formData && formData.serviceDuration}</th>
              </tr>

              <tr>
                <th>15</th>
                <th>कर्मचाऱ्यांचा जन्म दिनांक</th>
                <th>{formData && formData.birthDateNumber}</th>
              </tr>
              <tr>
                <th>16</th>
                <th>कर्मचाऱ्यांचा नेमणुक दिनांक</th>
                <th>{formData && formData.appointmentDate}</th>
              </tr>
              <tr>
                <th>१७</th>
                <th>कर्मचाऱ्यांचा सेवा निवृत्ती दिनांक</th>
                <th>{formData && formData.retirementDate}</th>
              </tr>

              <tr>
                <th>१८</th>
                <th>कर्मचाऱ्यांचे मुळ वेतन</th>
                <th>{formData && formData.baseSalary}</th>
              </tr>
              <tr>
                <th>१९</th>
                <th>
                  भविष्य निर्वाह निधी पासबुक वित्त विभागाकडून पडताळणी केली आहे
                  काय ?
                </th>
                <td> </td>
              </tr>
              <tr>
                <th> २०</th>
                <th>भविष्य निर्वाह निधी सिल्प प्रमाणे सन २०२०-२५ रक्कम</th>
                <td></td>
              </tr>

              <tr>
                <th>२१</th>
                <th>भविष्य निर्वाह निधी पासबुक प्रमाणे सन २०२१-२२ जमा रक्कम</th>
                <td> </td>
              </tr>
              <tr>
                <th>२२</th>
                <th>
                  भविष्य निर्वाह निधी प्रतिमहा कपात रक्कम माहे जमा रक्कम निरक
                </th>
                <td> </td>
              </tr>
              <tr>
                <th>२३</th>
                <th>भविष्य निर्वाह निधी उचल केली असल्यास</th>
                <td> निरं क</td>
              </tr>
              <tr>
                <th>२४</th>
                <th>सहावा वेतन आयोग पाचवा हप्ता देय बाकी असल्यास रक्कम</th>
                <td>निरं क</td>
              </tr>

              <tr>
                <th> २५</th>
                <th>
                  सहावा वेतन आयोग पहिला दुसरा हप्ता देय बाकी असल्यास रक्कम
                </th>
                <td>निरं क </td>
              </tr>
            </tbody>
          </table>

          <div>
            <table className="w-100 mt-2 m-auto ">
              <thead>
                <tr>
                  <th className="text-center">प्रमाणपत्र</th>
                </tr>
              </thead>
              <tbody>
                <td className="text-center p-3">
                  वरिल प्रमाणे १ ते २५ वर नमूद माहिती खरी असून महाराष्ट्र
                  सर्वसाधारण भ.नि.नि. नियम १९९८ च्या तरतुदी नुसार प्रस्तावाची
                  पडताळणी करुनच प्रस्ताव सादर केला आहे. तथापि, सदर प्रकरणी
                  अतिप्रदान झाल्याचे निदर्शनास आल्यास संबंधिताकडून अतिप्रदानाची
                  वसूली करुन देण्याची हमी घेण्यात आली आहे. करिता प्रमाणपत्र
                  देण्यात येत आहे
                </td>
              </tbody>
            </table>
          </div>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-6 col-6 col-md-6 text-center mt-3">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
            <div className="col-lg-6 col-6 col-md-6 text-center">
              <p className="fw-bold">{formData && formData.currentDistrict}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4" id="button-section">
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default GpfFinalPrint;
